import React from 'react';
import PropTypes from 'prop-types';

const TreeViewItemText = ({ title, description = null }) => (
  <div className="ws-ui-tree-view-item-text">
    <span className="ws-ui-tree-view-item-text__title">{title}</span>
    {description && <span className="ws-ui-tree-view-item-text__description">{description}</span>}
  </div>
);

TreeViewItemText.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
};

export default TreeViewItemText;
